import React, { useEffect, useReducer, useState } from 'react';
import { loadKpiIndicators, saveKpiIndicators } from '../actionCreators';
import FacilityKpiIndicatorsListContainer from './FacilityKpiIndicatorsListContainer';
import PropTypes from 'prop-types';
import { reducer, initialState } from '../reducers/containerReducer';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getFacilityKpiIndicators } from '../selectors';

const FacilityKpiIndicatorsContainer = ({
  documentId,
  siteId,
  isFromOffer,
  isFromFolder,
  isFromFacility,
  hasFacilityOffer,
  onParentFacilityStateChange,
  shouldSaveFromParent
}) => {
  const dispatch = useDispatch();
  const [localState, localDispatch] = useReducer(reducer, initialState);
  const [expanded, setExpanded] = useState(!isFromFolder);
  const { loaded, loading, kpiIndicators } = useSelector(state => getFacilityKpiIndicators(documentId, state), shallowEqual);

  useEffect(() => {
    if (!documentId || loaded || !expanded) return;
    dispatch(loadKpiIndicators(documentId, siteId));
  }, [documentId, expanded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!loaded) return;
    localDispatch({ type: 'OnInitState', kpiIndicators });
  }, [loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!shouldSaveFromParent || localState.isSaving) return;
    handleSave();
  }, [shouldSaveFromParent]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const onSaveCallBack = eventOk => {
    if (eventOk) {
      localDispatch({ type: 'OnSaveSucceeded', kpiIndicators });
      if (isFromOffer) {
        onParentFacilityStateChange('OnSaveSucceeded');
      }
      return;
    }
    localDispatch({ type: 'OnSaveFailed' });
    if (isFromOffer) {
      onParentFacilityStateChange('OnSaveFailed');
    }
  };

  const handleSave = () => {
    localDispatch({ type: 'OnSaveStarted' });
    if (isFromOffer) onParentFacilityStateChange('OnSaveStarted');
    dispatch(saveKpiIndicators(documentId, siteId, localState.kpiIndicators, onSaveCallBack));
  };

  const handleChange = index => value => {
    localDispatch({ type: 'OnPropertyChange', index, value });
    if (isFromOffer) onParentFacilityStateChange('OnPropertyChange');
  };

  return (
    <FacilityKpiIndicatorsListContainer
      handleSave={handleSave}
      kpiIndicators={localState.kpiIndicators}
      handleChange={handleChange}
      isSaving={localState.isSaving}
      isDirty={localState.isDirty}
      isFromOffer={isFromOffer}
      loading={loading}
      isFromFolder={isFromFolder}
      isFromFacility={isFromFacility}
      hasFacilityOffer={hasFacilityOffer}
      expanded={expanded}
      toggleExpanded={toggleExpanded}
    />
  );
};

FacilityKpiIndicatorsContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  isFromOffer: PropTypes.bool,
  isFromFolder: PropTypes.bool,
  isFromFacility: PropTypes.bool,
  hasFacilityOffer: PropTypes.bool,
  onParentFacilityStateChange: PropTypes.func,
  shouldSaveFromParent: PropTypes.bool
};

export default FacilityKpiIndicatorsContainer;
